import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {
  EntityServiceTransaction, InformationServiceTransaction,
  ServiceTransactionInitState, VerifyCodeInterface
} from '@/store/service-transaction/service-transaction.types';
import {MemberInitState, MemberTimeInformation, TimeInformation} from '@/store/member/member.types';
import {FormValidate} from '@/services/form-validate';
import {Toast} from '@/store/toast/toast.types';
import moment from 'moment';

interface ViewRating {
  topic: string;
  star: number;
}

@Component({
  components: {}
})
export default class PaymentRatingComponent extends Vue {
  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @State('member') memberInitState!: MemberInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_setRating', {namespace: 'serviceTransaction'}) setRating!: (star: number) => Promise<void>;

  public info = {} as InformationServiceTransaction;

  public changeStatus: boolean = false;
  public view: ViewRating = {
    topic: '',
    star: 0
  };

  async mounted() {
    try {
      this.Loading(true);
      this.view.star = 0;
      if (!this.serviceTransactionInitState.information.id) {
        this.$router.push('/payment-information').then();
      }
      this.info = this.serviceTransactionInitState.information;
      this.Loading(false);
    } catch (e) {
      this.Loading(false);
    }
  }

  changed() {
    this.changeStatus = true;
    this.setRating(this.view.star).then();
  }

  confirmRating() {
    if (this.changeStatus) {
      this.setRating(this.view.star).then();
      if (this.info.isOwner) {
        //คนสร้าง service
        this.$router.push('/payment-code-generate-end').then();
      } else {
        //
        this.$router.push('/payment-code-verify-end').then();
      }
    } else {
      this.Toast({
        type: 'warning',
        message: 'กรุณาให้คะแนน',
        heading: '!'
      }).then();

    }
    // this.$router.push('/payment-rating').then();
  }

}


